var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"kst-divider",class:_vm.theClass})
}
var staticRenderFns = []

export { render, staticRenderFns }